import { render } from "./AppToastMessage.vue?vue&type=template&id=3913241d"
import script from "./AppToastMessage.vue?vue&type=script&lang=js"
export * from "./AppToastMessage.vue?vue&type=script&lang=js"

import "./AppToastMessage.vue?vue&type=style&index=0&id=3913241d&lang=scss"

import exportComponent from "/Users/giovannivignone/VS Code Projects/gts-nft-collections/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__